import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
// import { SharedModule } from "../../app/components/shared/shared.module";
import {CoreRoutingModule} from './core-routing.module';
import {HomeComponent} from '../pages/home/home.component';
import {MainComponent} from '../pages/main/main.component';
import {HeaderComponent} from '../components/shared/header/header.component';
import { LoginComponent } from '../pages/login/login.component';
import { RegisterComponent } from '../pages/register/register.component';
import { OpenlinkComponent } from '../pages/openLink/openlink.component';
// import { ControlMessagesComponent } from '../components/control-messages/control-messages.component';
import { NextstepsComponent } from '../pages/nextsteps/nextsteps.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SpinnerComponent } from '../components/shared/spinner/spinner.component';
import { BuyerComponent } from '../pages/buyer/buyer.component';
import { SellerComponent } from '../pages/seller/seller.component';
import { SliderComponent } from '../pages/slider/slider.component';
// import { NotFoundComponent } from './not-found/not-found.component';
import { FooterComponent } from '../components/shared/footer/footer.component';
import {RouterModule} from '@angular/router';
import { AuthEffects } from '../../store/effects/auth.effects';
import { CategoryEffects  } from '../../store/effects/categories.effects';
import { UserEffects  } from '../../store/effects/user.effects';
import { BuyerEffects  } from '../../store/effects/buyer.effects';
import { SellerEffects  } from '../../store/effects/seller.effects';
import { ViewallComponent } from '../pages/viewall/viewall.component';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { StoreModule } from '@ngrx/store';
import { reducers } from '../../store/reducers';
import { EffectsModule } from '@ngrx/effects';
import { ListviewComponent } from '../pages/listview/listview.component';
import { MapviewComponent } from '../pages/mapview/mapview.component';
import { IndividualComponent } from '../pages/individual/individual.component';
import { OrganizationComponent } from '../pages/organization/organization.component';
//Interceptors
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import { HttpTokenInterceptor, ErrorInterceptor } from '../core/Interceptors/http.token.interceptor';

import { BsDropdownModule } from 'ngx-bootstrap'
import { CarouselModule } from 'ngx-bootstrap/carousel';
// import { ToastrModule } from 'ngx-toastr';
import { ToastrModule } from 'ng6-toastr-notifications';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
// import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "../../../src/app/components/shared/shared.module";
import { AnnouncementEffects } from '../../store/effects/announcement.effects';
import { OfferEffects } from '../../store/effects/offer.effects';


@NgModule({
  imports: [
    CommonModule, 
    CoreRoutingModule,
    ReactiveFormsModule,
    GooglePlaceModule,
    SharedModule,
    EffectsModule.forRoot([
      AuthEffects,
      CategoryEffects,
      UserEffects,
      BuyerEffects,
      SellerEffects,
      AnnouncementEffects,
      OfferEffects
    ]),
    StoreModule.forRoot(reducers, {}),
    CarouselModule.forRoot(),
    // NgxSpinnerModule,
    // SharedModule,
    BrowserAnimationsModule, // required animations module
    ToastrModule.forRoot(),
    BsDropdownModule.forRoot(),
    AngularFontAwesomeModule
    
  ],
  declarations: 
  [
    HomeComponent, 
    HeaderComponent, 
    MainComponent,
    LoginComponent,
    RegisterComponent,
    OpenlinkComponent,
    NextstepsComponent,
    // ControlMessagesComponent,
    FooterComponent,
    SellerComponent,
    BuyerComponent,
    SliderComponent,
    // SpinnerComponent,
    ViewallComponent,
    ListviewComponent, 
    MapviewComponent,
    IndividualComponent,
    OrganizationComponent
  ],
  exports: [RouterModule, HeaderComponent, FooterComponent],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpTokenInterceptor,
      multi: true,
    },

    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    }
  ],
})
export class CoreModule {}
